<ng-container *transloco="let t">
    <div class="card" *ngIf="escalation">
        <div class="card-header">
          {{ t('Edit your Escalation Procedure') }}
        </div>
        <div class="card-body">


            <form [formGroup]="formGroup" cForm>


                <div class="mb-3">
                  <label for="exampleFormControlTextarea1" class="form-label" >{{ t('Enter a custom escalation procedure:') }}</label>
                  <textarea class="form-control"  rows="8" formControlName="text"></textarea>
                </div>


                <c-row>
                  <c-col class="mt-3">
                    <button cButton class="px-4 text-white btn-info" type="submit" (click)="submitForm()">
                      <i class="fa-solid fa-check"></i> {{ t('Save') }}
                    </button>
                    <button cButton class="px-4" color="light" type="submit" (click)="cancel()">
                      <i class="fa-solid fa-times"></i> {{ t('Cancel') }}
                    </button>
                  </c-col>
                </c-row>
              </form>

        </div>
      </div>

</ng-container>
